export type ToolType =
  | 'draw' | 'erase' | 'fill' | 'pick'
  | 'select' | 'move'
  | 'rect' | 'circle' | 'ellipse' | 'triangle' | 'line'
  | 'brush' | 'polygon';

export type SymmetryMode = 'none' | 'horizontal' | 'vertical' | 'quad' | 'diagonal-fwd' | 'diagonal-bk' | 'radial-3' | 'radial-4' | 'radial-5' | 'radial-6' | 'radial-8' | 'radial-12' | 'star-5' | 'star-6' | 'star-8';
export type ShapeFillMode = 'outline' | 'filled';

export interface ToolState {
  activeTool: ToolType;
  activeColor: string;
  recentColors: string[];
  brushSize: number;
  symmetryMode: SymmetryMode;
  shapeFillMode: ShapeFillMode;
}

export const defaultToolState: ToolState = {
  activeTool: 'draw',
  activeColor: '#00ff9d',
  recentColors: ['#00ff9d', '#ff3cac', '#ffffff', '#000000'],
  brushSize: 1,
  symmetryMode: 'none',
  shapeFillMode: 'outline',
};
